// Formatuje datę ISO (YYYY-MM-DD) jako "15 maja" w pl-PL bez wpadki TZ.
//
// Problem: `new Date("2026-05-15")` parsuje się jako UTC midnight. W strefach
// na zachód od UTC (np. America/*) `toLocaleDateString` z lokalną strefą
// pokaże 14 maja zamiast 15. Dlatego parsujemy ręcznie YMD i konstruujemy
// datę w lokalnej strefie — wynik jest taki sam, jak ten, który `SearchForm`
// renderuje przez date-fns `format(...)` (też lokalny).
export function formatSearchDatePl(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return "";
  const [, y, mo, d] = m;
  const date = new Date(Number(y), Number(mo) - 1, Number(d));
  return date.toLocaleDateString("pl-PL", { day: "numeric", month: "long" });
}

// Krótki format: "15 maj" (bez końcówki "a") — używany w pasku formularza,
// gdzie pokazujemy zakres / multi: "15–22 maj", "15 maj +".
export function formatShortDatePl(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return "";
  const [, y, mo, d] = m;
  const date = new Date(Number(y), Number(mo) - 1, Number(d));
  return date.toLocaleDateString("pl-PL", { day: "numeric", month: "short" }).replace(/\.$/, "");
}

// Formatuje listę dat (ISO, posortowane lub nie) w jedną etykietę dla paska
// wyszukiwarki:
//   - 1 data        → "15 maj"
//   - zakres ciągły → "15–22 maj" (każdy dzień między min i max obecny)
//   - inne          → "15 maj +"  (najwcześniejsza + plus)
//
// `mode` może wymusić "+" zamiast detekcji ciągłości (multi-select user
// wybrał 3 niesąsiadujące dni, ale algorytmicznie są ciągłe → wciąż "+").
export function formatDateListLabel(
  dates: string[],
  mode: "single" | "range" | "multi" = "single",
): string {
  const valid = dates.filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)).sort();
  if (valid.length === 0) return "";
  if (valid.length === 1) return formatShortDatePl(valid[0]);
  const first = valid[0];
  const last = valid[valid.length - 1];
  if (mode === "range") {
    // "15–22 maj"
    const a = formatShortDatePl(first);
    const b = formatShortDatePl(last);
    // jeśli ten sam miesiąc, nie powtarzaj nazwy
    const aDay = a.split(" ")[0];
    return `${aDay}–${b}`;
  }
  // multi
  return `${formatShortDatePl(first)} +`;
}
